import { render, staticRenderFns } from "./Cfg.vue?vue&type=template&id=776ecad3&scoped=true&"
import script from "./Cfg.vue?vue&type=script&lang=js&"
export * from "./Cfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776ecad3",
  null
  
)

export default component.exports